import { render, staticRenderFns } from "./paper-move-to-folder.html?vue&type=template&id=45c2d408&scoped=true&"
import script from "./paper-move-to-folder.js?vue&type=script&lang=js&"
export * from "./paper-move-to-folder.js?vue&type=script&lang=js&"
import style0 from "./paper-move-to-folder.scss?vue&type=style&index=0&id=45c2d408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2d408",
  null
  
)

export default component.exports